module.exports = __webpack_public_path__ + "static/media/download_icon.35eaca2b.svg";